import * as Sentry from '@sentry/nextjs';
import { LEGIFRANCE_URL } from './consts/urls';

export const getLegiArticleLink = (articleId: string): string =>
    `${LEGIFRANCE_URL}/codes/article_lc/${articleId}`;

export const getLegiTextLink = (textId: string): string => `${LEGIFRANCE_URL}/loda/id/${textId}`;

export const getJorfArticleLink = (articleId: string): string =>
    `${LEGIFRANCE_URL}/jorf/id/${articleId}/#${articleId}`;

export const getJorfTextLink = (textId: string): string =>
    `${LEGIFRANCE_URL}/jorf/id/${textId}/#${textId}`;

export const getLegifranceLink = (docId: string): string => {
    switch (true) {
        case docId.startsWith('LEGIARTI'):
            return getLegiArticleLink(docId);
        case docId.startsWith('LEGITEXT'):
            return getLegiTextLink(docId);
        case docId.startsWith('JORFARTI'):
            return getJorfArticleLink(docId);
        case docId.startsWith('JORFTEXT'):
            return getJorfArticleLink(docId);
        default:
            Sentry.captureMessage(`getLegifranceLink: docId ${docId} not recognized.`);

            return LEGIFRANCE_URL;
    }
};
